import React, {useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link, NavLink, useLocation } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import  Box  from "@material-ui/core/Box";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import LoginButton from "../../Login/loginButton";
import { WebContext } from "../../../../Utility";
import Search from "../../navbarSearch";
import { NAVBAR_EXTERNAL_LINKS } from "../../../../Constants";
import { DesktopMenuDropdown } from "../mobileNavbar";

const useStyles = makeStyles((theme) => ({
  navbar: {
    height: 80,
    width: "100%",
    backgroundColor: "transparent",
    position: "relative",
    boxShadow: "1px 3px 12px rgba(0, 0, 0, 0.08)",
    display: "flex",
  },
  navLink: {
    height: "inherit",
    color: theme.agentTheme.card.link_foreground,
  },
  navBarContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: "inherit",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
    },
  },
  navBarLogo: {
    margin: "auto 0px",
    "& img": {
      width: "100%",
      objectFit: "contain",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "50%",
    },
  },
  navBarContent: {
    display: "flex",
    flexDirection: "row",
  },
  navBarText: {
    padding: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  navBarTextContainer: {
    marginRight: 20,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      height: "auto",
    },
  },
  navIcon: {
    margin: "auto 0px",
    color: theme.agentTheme.card.foreground,
    zIndex: 1,
  },
  navIconNonTransparent: {
    color: theme.agentTheme.card.foreground,
  },
  navTextHover: {
    "&:hover": {
      height: 80,
      backgroundColor: theme.agentTheme.primary.main,
      color: theme.agentTheme.primary.foreground,
    },
    "&$activeNavItem": {
      height: 80,
      backgroundColor: theme.agentTheme.primary.main,
      color: theme.agentTheme.primary.foreground,
    },
  },
  activeNavItem: {
    backgroundColor: theme.agentTheme.primary.main,
    color: theme.agentTheme.primary.foreground,
  },
  searchDiv: {
    margin: "auto 8px",
    width: "25%",
    [theme.breakpoints.down("sm")]: {
      width: "40%",
    },
  },
  loginButton: {
    marginTop: "20px",
    color: theme.agentTheme.primary.main,
    [theme.breakpoints.down("sm")]: {
      marginTop: "0px",
    },
  },
}));

export default (props) => {
  let {
    logo_url = "",
    contentArr = [],
    username = "",
    getLogoUrl,
    isMobile = false,
    toggleMenu: mobileNavBarOpen = false,
    memberProfile,
    onNavIconClick,
    setToggleMenu,
    handleCovidMenuClose,
    handleCovidMenuItemClick,
    loginItem,
  } = props || {};
  const classes = useStyles();
  const location = useLocation();
  const { isLoggedIn = false } = useContext(WebContext);
  const [isLoginMenu, setIsLoginMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [clickItem, setClickItem] = useState([]);
  const { website_modules: websiteModules = {} } = memberProfile || {};
  const { packages: isPackagesEnabled = true } = websiteModules || {};
  const handleCovidMenuClick = (
    event,
    clickItemParam = [],
    islogin = false
  ) => {
    setIsLoginMenu(islogin);
    if (clickItemParam.length > 0) setClickItem(clickItemParam);
    if (anchorEl == null) setAnchorEl(event.currentTarget);
    else handleCovidMenuClose();
  };
  const getNavItem = () => {
    return (
      <>
        {contentArr.map((item, index) => {
          let showActive = false;
          if (location.pathname == item.link) showActive = true;
          else if (location.pathname == "/" && item.link == `/${username}`)
            showActive = true;
          else if (item.clickHandle) {
            item.clickItem.map((element) => {
              if (
                element.link == location.pathname ||
                element.link.pathname == location.pathname
              )
                showActive = true;
            });
          }
          if (mobileNavBarOpen) {
          } else {
            if (item.clickHandle) {
              return (
                <>
                  <div
                    className={`${classes.navTextHover} ${
                      classes.navBarTextContainer
                    } ${showActive && classes.activeNavItem} ${
                      classes.navLink
                    }`}
                    onClick={(e) => handleCovidMenuClick(e, item.clickItem)}
                    key={index}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label} {item.dropdown && <KeyboardArrowDown />}
                    </Typography>
                  </div>
                </>
              );
            } else {
              const isExternalLink = NAVBAR_EXTERNAL_LINKS.includes(
                item.label.toLowerCase()
              );
              return isExternalLink ? (
                <a href={item.link} className={classes.navLink}>
                  <div
                    className={`${classes.navTextHover} ${
                      classes.navBarTextContainer
                    } ${showActive && classes.activeNavItem}`}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label} {item.dropdown && <KeyboardArrowDown />}
                    </Typography>
                  </div>
                </a>
              ) : (
                <NavLink
                  to={{
                    pathname: item.link,
                    hash: item.hash || "",
                    state: { memberProfileData: memberProfile },
                  }}
                  className={classes.navLink}
                >
                  <div
                    className={`${classes.navTextHover} ${
                      classes.navBarTextContainer
                    } ${showActive && classes.activeNavItem}`}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label} {item.dropdown && <KeyboardArrowDown />}
                    </Typography>
                  </div>
                </NavLink>
              );
            }
          }
        })}
      </>
    );
  };
  return (
    <div className={`${classes.navbar}`}>
      <Container maxWidth={false} className={classes.navBarContainer}>
        <div className={classes.navBarLogo}>
          {isMobile && (
            <div
              className={`${classes.navIcon} ${
                !mobileNavBarOpen && classes.navIconNonTransparent
              }`}
            >
              {!mobileNavBarOpen ? (
                <MenuIcon onClick={onNavIconClick} />
              ) : (
                <CloseIcon onClick={onNavIconClick} />
              )}
            </div>
          )}
          {!isMobile && logo_url && (
            <Link to={`/${username ? `${username}` : ""}`}>
              <img src={getLogoUrl(logo_url)} height="70" />
            </Link>
          )}
        </div>
        {isMobile && logo_url && (
          <>
            <Link to={`/${username ? `${username}` : ""}`}>
              <img src={getLogoUrl(logo_url)} height="70" />
            </Link>
            <LoginButton loginClass={classes.loginButton} />
          </>
        )}
        {!isMobile && isPackagesEnabled && (
          <div className={classes.searchDiv}>
            <Search type="NAVBAR_SEARCH_2" />
          </div>
        )}
        {!isMobile && (
          <div className={classes.navBarContent}>
            {getNavItem()}
            {!isMobile && (
              <Box
                onClick={(e) => isLoggedIn && handleCovidMenuClick(e, [], true)}
              >
                <LoginButton loginClass={classes.loginButton} />
              </Box>
            )}
          </div>
        )}
      </Container>
      {(isLoginMenu || clickItem.length > 0) && (
        <DesktopMenuDropdown
          anchorEl={anchorEl}
          handleCovidMenuClose={handleCovidMenuClose}
          loginMenu={isLoginMenu}
          clickItem={isLoginMenu ? loginItem : clickItem}
          handleCovidMenuItemClick={handleCovidMenuItemClick}
        />
      )}
    </div>
  );
};
